import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { ReturnDetails } from "../../returns.types";
import { requestGetReturnDetails } from "./getReturnDetails.request";

const useGetReturnDetails = (
  id: string,
  options?: QueryOptions<ReturnDetails, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["order", "admin", "return-details", id],
    queryFn: async () => await requestGetReturnDetails(id),
    onError: toastServerError,
    ...options
  });

  return { returnDetails: data, ...rest };
};

export default useGetReturnDetails;
